export default {
  endpoint: "https://td-travel.ru/api",
  imagesBaseUrl: "https://td-travel.ru"
};
